// Statistics Actions Types

export const LOAD_STATISTICS_SPREADSHEET = 'LOAD_STATISTICS_SPREADSHEET';
export const CLEAR_STATISTICS_SPREADSHEET = 'CLEAR_STATISTICS_SPREADSHEET';

export const LOAD_STATISTICS_CHARTS = 'LOAD_STATISTICS_CHARTS';
export const CLEAR_STATISTICS_CHARTS = 'CLEAR_STATISTICS_CHARTS';

export const RESET_STATISTICS_STORAGE = 'RESET_STATISTICS_STORAGE';

